/**
 * @generated SignedSource<<e44b7bf63d841e43ab0c99ce632182bf>>
 * @relayHash a2b4f79ba8694b8a2d5afbaf9da0fcb0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4f0dfbbfc5c4fa6e0daaf56d8218ccb97b40043f636316a0df8b893f60d7ec2a

import type { ConcreteRequest } from 'relay-runtime';
export type GraphQLFrontCoverState = "HIDDEN" | "SHOWN" | "TRANSITION" | "UNSET" | "%future added value";
export type UpdateSiteLookAndFeelInput = {
  backgroundColor?: string | null | undefined;
  faviconFiles: ReadonlyArray<FaviconFileInput>;
  frontCoverState?: GraphQLFrontCoverState | null | undefined;
  highlightColor?: string | null | undefined;
  resetFavicon?: boolean | null | undefined;
  resetSiteLogo?: boolean | null | undefined;
  showFrontCover?: boolean | null | undefined;
  showSiteName?: boolean | null | undefined;
  siteLogoFileStoreId?: string | null | undefined;
  siteName?: string | null | undefined;
};
export type FaviconFileInput = {
  fileStoreId: string;
  filename: string;
};
export type useChangeCompanyHubPublishStateChangeHubPublishStateMutation$variables = {
  input: UpdateSiteLookAndFeelInput;
};
export type useChangeCompanyHubPublishStateChangeHubPublishStateMutation$data = {
  readonly updateSiteLookAndFeel: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly siteLookAndFeel: {
      readonly frontCoverState: string | null | undefined;
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useChangeCompanyHubPublishStateChangeHubPublishStateMutation = {
  response: useChangeCompanyHubPublishStateChangeHubPublishStateMutation$data;
  variables: useChangeCompanyHubPublishStateChangeHubPublishStateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "concreteType": "SiteLookAndFeel",
  "kind": "LinkedField",
  "name": "siteLookAndFeel",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "frontCoverState"
    }
  ]
},
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "kind": "ScalarField",
  "name": "message"
},
v5 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v6 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useChangeCompanyHubPublishStateChangeHubPublishStateMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "UpdateSiteLookAndFeelPayload",
        "kind": "LinkedField",
        "name": "updateSiteLookAndFeel",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useChangeCompanyHubPublishStateChangeHubPublishStateMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "UpdateSiteLookAndFeelPayload",
        "kind": "LinkedField",
        "name": "updateSiteLookAndFeel",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "a2b4f79ba8694b8a2d5afbaf9da0fcb0",
    "id": "4f0dfbbfc5c4fa6e0daaf56d8218ccb97b40043f636316a0df8b893f60d7ec2a",
    "metadata": {},
    "name": "useChangeCompanyHubPublishStateChangeHubPublishStateMutation",
    "operationKind": "mutation",
    "text": "mutation useChangeCompanyHubPublishStateChangeHubPublishStateMutation($input:UpdateSiteLookAndFeelInput!){updateSiteLookAndFeel(input:$input){siteLookAndFeel{frontCoverState},success,errors{message,extensions{__typename,errorType,statusCode,...on BulkMutationErrorExtension{id}}}}}"
  }
};
})();

(node as any).hash = "5001b4614b3c544c07ab66e207d7fc69";

export default node;
